import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MaterialModule } from "@assoanalytics/app/material.module";

@Component({
  selector: "app-alert-dialog",
  templateUrl: "./alert-dialog.component.html",
  styleUrls: ["./alert-dialog.component.scss"],
  imports: [MaterialModule],
})
export class AlertDialogComponent {
  title: string;
  messages: string[];
  type: "default" | "warning";
  confirm?: string;
  cancel?: string;

  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      title: string;
      messages: string[];
      type: "default" | "warning";
      confirm?: string;
      cancel?: string;
    },
  ) {
    this.title = data.title;
    this.messages = this.decodeHtml(data.messages);
    this.confirm = data.confirm;
    this.cancel = data.cancel;
    this.type = data.type;
  }

  cancelAction() {
    return this.dialogRef.close(false);
  }

  confirmAction() {
    this.dialogRef.close(true);
  }

  isDefault() {
    return this.type === "default";
  }

  isWarning() {
    return this.type === "warning";
  }

  private decodeHtml(htmlArray: string[]): string[] {
    const parser = new DOMParser();
    const htmlEncodedRegex = /&[#0-9a-zA-Z]+;/; // Regex per rilevare caratteri HTML encoded

    return htmlArray.map((html) => {
      // Se la stringa contiene caratteri HTML encoded, decodifica
      if (htmlEncodedRegex.test(html)) {
        const doc = parser.parseFromString(html, "text/html");
        return doc.documentElement.textContent || "";
      }
      // Altrimenti, restituisci la stringa così com'è
      return html;
    });
  }
}
